// test1969
(1969 && 0);
